import axios, {AxiosInstance, AxiosRequestConfig, InternalAxiosRequestConfig} from 'axios';
import AuthorizationModuleFacade from "shared/src/modules/authModule/store/authorizationModule.facade";

const AXIOS_INSTANCE_CONFIG: AxiosRequestConfig = {
  baseURL: '',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  },
};

const requestTokenHandler = (config: InternalAxiosRequestConfig) => {

  if (typeof config.headers === 'undefined') {
    return config;
  }

  if(AuthorizationModuleFacade.accessToken) {
    config.headers.Authorization = `Bearer ${AuthorizationModuleFacade.accessToken}`;
  }

  return config;
};

export const getAxiosInstance = (): AxiosInstance => {
  const instance = axios.create(AXIOS_INSTANCE_CONFIG);

  instance.interceptors.request.use(requestTokenHandler);

  return instance;
};

export const axiosInstance: AxiosInstance = getAxiosInstance();
